__turbopack_context__.v({
  "modalBody": "UGFGWa_modalBody",
  "modalContent": "UGFGWa_modalContent",
  "modalFooter": "UGFGWa_modalFooter",
});
